import { render, staticRenderFns } from "./SavedListMeta.vue?vue&type=template&id=c4989e00&"
import script from "./SavedListMeta.vue?vue&type=script&lang=js&"
export * from "./SavedListMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports